import { useCallback, useEffect, useRef, useState } from 'react';
import './main.css';
import '../App.css';
import { useSpring, animated } from 'react-spring';
import '@fortawesome/fontawesome-free/css/all.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { handleVibration, changeNum, changeUnitsOrigial, changeUnits } from './common/function';
import { changeAlramModal, changeEnergy, changeGold, checkDuplicateLogins, checkLimitUpgrade, checkLimitUpgradeValue, checkTapUpgrade, checkTapUpgradeValue } from '../store';
import axios from 'axios';
import { BeatLoader } from "react-spinners";
import MessageModal from './messageModal';
import { useTranslation } from "react-i18next";
import SlotCounter from 'react-slot-counter';
import ProgressBar from '@ramonak/react-progress-bar';
import AOS from 'aos';
import 'aos/dist/aos.css';

import { FreeMode, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import useWindowSize from '../hook/useWindowSize'
import { useActionState } from 'react';

let jackpotdelay = false

function Main() {
    const { t } = useTranslation();
    const JWT = useSelector((state) => { return state.JWT.value })
    const jackpot = useSelector((state) => { return state.jackpot })
    const superJackpot = useSelector((state) => { return state.superJackpot })
    const mySkin = useSelector((state) => { return state.mySkin })
    const gold = useSelector((state) => { return state.gold.value })
    const energy = useSelector((state) => { return state.energy.value })
    const tapUpgradeValue = useSelector((state) => { return state.tapUpgradeValue.value })
    const limitUpgradeValue = useSelector((state) => { return state.limitUpgradeValue.value })
    const JackpotImg = useSelector((state) => { return state.JackpotImg })
    const myData = useSelector((state) => { return state.myData })
    const circleImg = useSelector((state) => { return state.circleImg.value })
    const mobileType = useSelector((state) => { return state.mobileType.value })
    const banner = useSelector((state) => { return state.banner })
    const JackpotSound = useSelector((state) => { return state.JackpotSound.value })
    const SuperJackpotImg = useSelector((state) => { return state.SuperJackpotImg.value })
    const shoppingState = useSelector((state) => { return state.shoppingState.value })

    let haptic = useSelector((state) => { return state.haptic.value })
    let sound = useSelector((state) => { return state.sound.value })

    let dispatch = useDispatch()
    let navigate = useNavigate()
    let location = useLocation()

    const { Rwidth, Rheight } = useWindowSize();

    const imageRef = useRef(null);
    const [infoModal, setInfoModal] = useState(false)
    const [jackpotWhale, setJackpotWhale] = useState(false)
    const [superJackpotBox, setSuperJackpotBox] = useState(false)
    const [showGoldText, setShowGoldText] = useState(false);
    const [jackpotAmt, setJackpotAmt] = useState(0)
    const [textPosition, setTextPosition] = useState({ top: 50, left: 60 });
    const [upgrade, setUpgrade] = useState([])
    const [checkEnergy, setCheckEnergy] = useState(energy)

    const [message, setMessage] = useState("");

    const imgRef = useRef(null)
    const [adsHeightState, setAdsHeightState] = useState(0);

    const [clickBudgetId, setClickBudgetId] = useState("")
    const [clickSuperJackpotId, setClickSuperJackpotId] = useState("")
    const [superText, setSuperText] = useState("")
    const [SuperBoxModal, setSuperBoxModal] = useState(false)
    const [SuperBoxTextModal, setSuperBoxTextModal] = useState(false)

    const [centerImgLoad, setCenterImgLoad] = useState(false)
    const [bangState, setBangState] = useState(true)

    const swiperRef = useRef(null);

    useEffect(() => {
        const preloadImages = async () => {
            if (!banner || banner.length === 0) return;

            // 이미지 미리 로딩
            await Promise.all(
                banner.map(
                    (item) =>
                        new Promise((resolve) => {
                            const img = new Image();
                            img.src = `${process.env.REACT_APP_API}${item.ad_img}`;
                            img.onload = resolve;
                            img.onerror = resolve;
                        })
                )
            );

            // 이미지 로드가 끝난 뒤, DOM이 어느 정도 잡히도록
            // 짧은 지연 시간을 주고 Swiper 인스턴스 업데이트
            setTimeout(() => {
                if (swiperRef.current?.swiper) {
                    const swiperInstance = swiperRef.current.swiper;
                    swiperInstance.update();
                    swiperInstance.slideToLoop(0, 0); // 첫 슬라이드로 이동
                    swiperInstance.autoplay.start();
                }
            }, 100); // 0.1초 뒤에 실행
        };
        preloadImages();
    }, [banner, location.pathname]);

    const audioCtxRef = useRef(null);
    const buffersRef = useRef({});

    useEffect(() => {
        // AudioContext 생성
        audioCtxRef.current = new (window.AudioContext || window.webkitAudioContext)();

        // iOS Safari를 위한 초기 resume 처리
        const handleFirstTouch = () => {
            if (audioCtxRef.current.state === 'suspended') {
                audioCtxRef.current.resume();
            }
            // 한 번만 실행되도록 제거
            window.removeEventListener('touchstart', handleFirstTouch);
            window.removeEventListener('mousedown', handleFirstTouch);
        };

        window.addEventListener('touchstart', handleFirstTouch, { once: true });
        window.addEventListener('mousedown', handleFirstTouch, { once: true });

        handleFirstTouch()
        // 사운드 로드
        loadAudioBuffer('jackpot', JackpotSound.find(item => item.sound_nm === "jackpot_sound")?.sound_url ?? "");
        loadAudioBuffer('superJackpot', JackpotSound.find(item => item.sound_nm === "superjackpot_sound")?.sound_url ?? "");
        loadAudioBuffer('sound', JackpotSound.find(item => item.sound_nm === "jackpot_win_sound")?.sound_url ?? "");
        loadAudioBuffer('click', JackpotSound.find(item => item.sound_nm === "tap_sound")?.sound_url ?? "");
    }, []);

    const loadAudioBuffer = async (key, url) => {
        if (!audioCtxRef.current || !url) return;

        try {
            let res;

            if (url.startsWith("http")) {
                // 외부 URL 처리
                res = await fetch(url, {
                    mode: "cors",         // CORS 허용
                    cache: "no-store"     // 외부 URL은 캐시 비활성화
                });
            } else {
                // 로컬 파일(public/sound/*)
                res = await fetch(url, {
                    cache: "force-cache"
                });
            }

            if (!res.ok) {
                throw new Error(`HTTP error! status: ${res.status}`);
            }

            const arrayBuffer = await res.arrayBuffer();
            const decodedBuffer = await audioCtxRef.current.decodeAudioData(arrayBuffer);
            buffersRef.current[key] = decodedBuffer;
            console.log(`[${key}] audio buffer loaded from ${url}`);
        } catch (err) {
            console.error(`Error loading ${key} (${url}):`, err);
        }
    };


    const playAudioWithContext = (key, duration) => {
        const ctx = audioCtxRef.current;
        const buffer = buffersRef.current[key];

        if (!ctx || !buffer) return;

        if (ctx.state === 'suspended') {
            ctx.resume();
        }

        const source = ctx.createBufferSource();
        source.buffer = buffer;

        // 볼륨을 항상 동일하게 설정하는 GainNode
        const gainNode = ctx.createGain();
        gainNode.gain.value = 1.0; // 모든 터치 시 동일 볼륨

        source.connect(gainNode);
        gainNode.connect(ctx.destination);

        source.start(0);

        if (duration) {
            source.stop(ctx.currentTime + duration / 1000);
        }
    };

    useEffect(() => {
        const handleResize = () => {
            const windowHeight = window.innerHeight;

            if (windowHeight <= 580) {
                setAdsHeightState(1)
            } else if (windowHeight <= 650) {
                setAdsHeightState(2)
            } else if (windowHeight <= 720) {
                setAdsHeightState(3)
            } else {
                setAdsHeightState(0)
            }
        };

        handleResize();

    }, [Rheight]);

    useEffect(() => {
        UpgradeData()
    }, [])

    const UpgradeData = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/upgrade', {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setUpgrade(tmp?.data?.up ?? 0)
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    // 배경 기울기 애니메이션 설정
    const [tiltStyle, tiltApi] = useSpring(() => ({
        transform: 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale(1)',
        config: { tension: 600, friction: 10 },
    }));

    // 햄스터 점프 애니메이션 설정
    const [jumpStyle, jumpApi] = useSpring(() => ({
        transform: 'translate(-50%, -50%) translateY(0px)', // 초기 위치
        config: { tension: 200, friction: 12 },
    }));

    const [hearts, setHearts] = useState([]);

    const handlePointerDown = useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();

        if (sound) playAudioWithContext('click', 700);
        if (haptic) handleVibration(1);

        const { clientX, clientY } = event;

        const rect = imgRef.current.getBoundingClientRect();
        const imageX = rect.left; // 이미지의 x 위치
        const imageY = rect.top;

        const newHeart = {
            id: Date.now() + Math.random(),
            x: clientX - imageX - 25,
            y: clientY - imageY - 60,
        };

        if (energy > 0) {
            const newGold = gold + tapUpgradeValue;
            const newEnergy = energy - 1;

            // 골드와 에너지 상태 업데이트
            dispatch(changeGold(newGold));
            dispatch(changeEnergy(newEnergy));
            setCheckEnergy(energy)

            // 로컬스토리지에 저장할 로그 항목 생성
            const newLogGold = {
                amount: tapUpgradeValue,
                balance: newGold,
                time: new Date()
            };
            const newLogEnergy = {
                amount: 1,
                balance: newEnergy,
                time: new Date()
            };

            // 기존 골드 로그 배열을 불러오고, 새로운 항목 추가
            const storedGoldLogs = JSON.parse(localStorage.getItem("goldLogs")) || [];
            storedGoldLogs.push(newLogGold);

            // 기존 에너지 로그 배열을 불러오고, 새로운 항목 추가
            const storedEnergyLogs = JSON.parse(localStorage.getItem("energyLogs")) || [];
            storedEnergyLogs.push(newLogEnergy);

            // 로컬스토리지에 업데이트된 로그 배열을 저장
            localStorage.setItem("goldLogs", JSON.stringify(storedGoldLogs));
            localStorage.setItem("energyLogs", JSON.stringify(storedEnergyLogs));

            if (storedGoldLogs.length == 10) {
                GoldBulk(storedGoldLogs)
                localStorage.removeItem("goldLogs");
            }
            else if (storedGoldLogs.length > 10) {
                const remainingLogs = storedGoldLogs.slice(10);
                localStorage.setItem("goldLogs", JSON.stringify(remainingLogs));
            }
            if (storedEnergyLogs.length == 10) {
                EnergyBulk(storedEnergyLogs)
                localStorage.removeItem("energyLogs");
            }
            else if (storedEnergyLogs.length > 10) {
                const remainingLogs = storedEnergyLogs.slice(10);
                localStorage.setItem("energyLogs", JSON.stringify(remainingLogs));
            }

            checkTimeAndLog() // 잭팟 확률 체크
        }
        else {
            if (checkEnergy >= 0) {
                setCheckEnergy(e => e - 1)
            }
        }

        setHearts((prevHearts) => [...prevHearts, newHeart]);

        setTimeout(() => {
            setHearts((prevHearts) => prevHearts.filter((h) => h.id !== newHeart.id));
        }, 1000);

        applyTilt(event); // 배경 기울기 적용
        applyJump(); // 햄스터 점프 애니메이션 실행
    }, [gold, energy, jackpot, haptic, sound, superJackpot]);

    const GoldBulk = async (storedGoldLogs) => {
        const tg = window.Telegram.WebApp;
        tg.ready();

        await axios.post(process.env.REACT_APP_API + '/api/gold/bulk', {
            goldBulk: storedGoldLogs
        }, {
            headers: { Authorization: `Bearer ${tg.initData}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const EnergyBulk = async (storedEnergyLogs) => {
        const tg = window.Telegram.WebApp;
        tg.ready();
        await axios.post(process.env.REACT_APP_API + '/api/energy/bulk', {
            energyBulk: storedEnergyLogs
        }, {
            headers: { Authorization: `Bearer ${tg.initData}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const applyTilt = (e) => {
        const card = imageRef.current;
        if (!card) return;

        const { width, height, left, top } = card.getBoundingClientRect();
        const x = e.clientX - left - width / 2;
        const y = e.clientY - top - height / 2;

        const rotateX = (-y / 10).toFixed(2); // `-` sign to match `handleCardClick`
        const rotateY = (x / 10).toFixed(2);

        tiltApi.start({
            transform: `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1)`,
        });
    };

    const resetTilt = () => {
        tiltApi.start({
            transform: 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale(1)',
        });
    };

    const applyJump = () => {
        // 위로 20px 점프 후 복귀
        jumpApi.start({
            transform: 'translate(-50%, -50%) translateY(-6px)', // 위로 이동
        });
        setTimeout(() => {
            jumpApi.start({
                transform: 'translate(-50%, -50%) translateY(0px)', // 원래 위치로 복귀
            });
        }, 100); // 200ms 후 원래 위치로 복귀
    };

    const WhaleplayAudio = (type) => {
        if (sound) {
            playAudioWithContext(type === 1 ? 'jackpot' : 'superJackpot', 10000);
        }
        setTimeout(() => {
            if (type === 1) setJackpotWhale(true);
            else if (type === 2) setSuperJackpotBox(true)
        }, 9000);
    };

    const playAudio = () => {
        playAudioWithContext('sound', 2000);
    };

    const onClickWhale = (e) => {
        // requestAnimationFrame을 사용하여 오디오와 상태 업데이트를 지연 처리
        requestAnimationFrame(() => {
            if (sound) playAudio();
            const newGold = gold + jackpotAmt;

            // 골드 상태 업데이트
            dispatch(changeGold(newGold));

            // 이미지 위치를 텍스트에 적용
            const rect = e.target.getBoundingClientRect();
            setTextPosition({
                top: rect.top + window.scrollY,
                left: rect.left + window.scrollX
            });

            // 이미지와 텍스트 표시 관리
            setJackpotWhale(false); // 이미지 숨기기
            setShowGoldText(true);

            // 텍스트 일정 시간 후 사라지기
            setTimeout(() => {
                setShowGoldText(false);
            }, 1000); // 1초 후 사라짐

            if (haptic) handleVibration(10);

            ClickJackpot(clickBudgetId)
        });
    };

    const onClickBox = (e) => {
        // requestAnimationFrame을 사용하여 오디오와 상태 업데이트를 지연 처리
        requestAnimationFrame(() => {
            // 이미지와 텍스트 표시 관리
            // if (sound) playAudio();
            setSuperJackpotBox(false); // 이미지 숨기기

            setTimeout(() => {
                setSuperBoxModal(true)
            }, 100)

            setTimeout(() => {
                setSuperBoxTextModal(true)
            }, 3300)

            setTimeout(() => {
                setSuperBoxModal(false);
                setSuperBoxTextModal(false)
            }, 6500); // 1초 후 사라짐

            if (haptic) handleVibration(10);
            console.log("슈퍼잭팟 클릭")
            ClickSuperJackpot(clickSuperJackpotId)
        });
    };

    const checkTimeAndLog = () => {
        // 조건에 맞는지 확인
        let random = Math.random();

        if (!jackpotdelay && energy > 0) {
            console.log(superJackpot)
            if (superJackpot?.superJackpot && random <= superJackpot?.winProbability / 100) {
                console.log("**********슈퍼잭팟당첨************")
                jackpotdelay = true
                SuperJackpot()
            }
            else {
                console.log(jackpot)
                for (let i = 0; i < jackpot?.jackpotSlotRows?.length; i++) {
                    let pot = jackpot.jackpotSlotRows[i];

                    // 현재 시간 가져오기
                    const now = new Date();
                    const currentHour = now.getHours();
                    const currentMin = now.getMinutes();
                    const currentSec = now.getSeconds();

                    // 문자열 시간("HH:MM:SS")을 분리하여 숫자로 변환
                    const [startHour, startMin, startSec] = pot.start_time.split(':').map(Number);
                    const [endHour, endMin, endSec] = pot.end_time.split(':').map(Number);

                    // 현재 시간이 시작 시간 이후인지 확인
                    const isAfterStart =
                        currentHour > startHour ||
                        (currentHour === startHour && currentMin > startMin) ||
                        (currentHour === startHour && currentMin === startMin && currentSec >= startSec);

                    // 현재 시간이 종료 시간 이전인지 확인
                    const isBeforeEnd =
                        currentHour < endHour ||
                        (currentHour === endHour && currentMin < endMin) ||
                        (currentHour === endHour && currentMin === endMin && currentSec < endSec);

                    if (isAfterStart && isBeforeEnd && pot.possible) {
                        let random1 = Math.random();
                        if (random1 <= jackpot?.winProbability / 100) {
                            console.log("**********잭팟당첨************")
                            jackpotdelay = true
                            Jackpot()
                        }
                    }
                }
            }
        }
    };

    const Jackpot = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/jackpot/check', {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setBangState(true)
                WhaleplayAudio(1);
                setClickBudgetId(tmp?.data?.jackpotId ?? "");
                setJackpotAmt(tmp?.data?.reward ?? 0);
            } else if (tmp?.code == -1000) {
                setBangState(false)
                WhaleplayAudio(1);
                setClickBudgetId(tmp?.data?.jackpotId ?? "");
                setJackpotAmt(tmp?.data?.reward ?? 0);
            }
            setTimeout(() => {
                setJackpotWhale(false);
                jackpotdelay = false
            }, 20 * 1000)
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const SuperJackpot = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/super-jackpot/check', {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            console.log(tmp)
            if (tmp?.code == 1000) {
                WhaleplayAudio(2);
                setClickSuperJackpotId(tmp?.data?.superJackpot?.sj_id ?? "")
                setSuperText(tmp?.data?.superJackpot?.sj_name ?? "")
            }
            setTimeout(() => {
                setSuperJackpotBox(false);
                ClickSuperJackpotFail(tmp?.data?.superJackpot?.sj_id ?? "")
                jackpotdelay = false
            }, 20 * 1000)
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const ClickJackpot = async (id) => {
        await axios.post(process.env.REACT_APP_API + '/api/jackpot/win', {
            jackpotId: id
        }, {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setClickBudgetId("")
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const ClickSuperJackpot = async (id) => {
        await axios.post(process.env.REACT_APP_API + '/api/super-jackpot/win', {
            sjId: id
        }, {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            console.log(tmp)
            if (tmp?.code == 1000) {
                setClickSuperJackpotId("")
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const ClickSuperJackpotFail = async (id) => {
        await axios.post(process.env.REACT_APP_API + '/api/super-jackpot/fail', {
            sjId: id
        }, {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            console.log(tmp)
            if (tmp?.code == 1000) {
                setClickSuperJackpotId("")
                setSuperText("")
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const thresholds = [0, 50];
    const maxInvite = thresholds[thresholds.length - 1];
    const [invitedCount, setInvitedCount] = useState(20);

    useEffect(() => {
        AOS.init();
    })

    return (
        <div className="main" style={{ paddingTop: adsHeightState === 1 || adsHeightState === 3 ? "55px" : "105px" }}>
            <MessageModal message={message} />
            {infoModal && (<AirdropModal setInfoModal={setInfoModal} upgrade={upgrade} setMessage={setMessage} />)}
            <div className="main-box">
                {(adsHeightState === 3 || adsHeightState === 0) && (
                    <Swiper
                        ref={swiperRef}
                        slidesPerView={1}
                        spaceBetween={20}
                        pagination={{
                            clickable: true,
                            dynamicBullets: true,
                        }}
                        modules={[FreeMode, Autoplay, Pagination]}
                        loop={true}
                        autoplay={{
                            delay: 3000, // 3초 간격
                            disableOnInteraction: false,
                        }}
                        speed={1000}
                        className="swiper ay_Swiper4 style_dot2"
                        style={{ zIndex: "101" }}
                    >
                        {banner.map((item, i) => (
                            <SwiperSlide key={i}>
                                <div className="main-1">
                                    <div
                                        className="main-ads"
                                        style={{
                                            width: '100%',
                                            aspectRatio: '4/1',
                                            backgroundImage: `url(${process.env.REACT_APP_API}${item.ad_img})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat',
                                            borderRadius: '10px',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => item.ad_redirect_url == "/shopping"
                                            ? navigate(item.ad_redirect_url)
                                            : item.ad_redirect_url == "/wallet"
                                                ? window.location.href = shoppingState ? 'https://dev.saypot.ttory.com/wallet' : 'https://saypot.ttory.com/wallet'
                                                : window.open(item.ad_redirect_url, '_blank')}
                                    />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                )}
                <>
                    {jackpotWhale && (
                        <motion.img
                            src={
                                bangState
                                    ?
                                    JackpotImg.filter((img) => jackpotAmt >= img.gold_rate) // 조건에 맞는 항목 필터링
                                        .sort((a, b) => b.gold_rate - a.gold_rate)[0]?.url || '' // 내림차순 정렬 후 첫 번째 항목 선택
                                    :
                                    "/newImg/bomb.png"
                            }
                            style={{
                                position: 'absolute',
                                top: '30px',
                                left: '0',
                                zIndex: '1000',
                            }}
                            initial={{ x: '100vw', y: '100px' }} // 오른쪽 화면 밖에서 시작
                            animate={{
                                x: '-300px', // 왼쪽 화면 밖으로 이동
                                y: [100, 70, 100, 70, 100], // 물결 모양으로 위아래로 움직임
                            }}
                            onClick={onClickWhale}
                            transition={{
                                duration: 10, // 10초 동안 이동
                                ease: 'linear', // 일정한 속도로 이동
                                y: {
                                    duration: 3, // y축 이동의 반복 주기
                                    repeat: Infinity,
                                    ease: 'linear',
                                },
                            }}
                        />
                    )}

                    {superJackpotBox && (
                        <motion.img
                            src={SuperJackpotImg?.image?.[0]?.img_url ?? "/newImg/pink_dolphin.png"}
                            style={{
                                position: 'absolute',
                                top: '30px',
                                left: '0',
                                zIndex: '1000',
                                // width: "150px"
                            }}
                            initial={{ x: '100vw', y: '100px' }} // 오른쪽 화면 밖에서 시작
                            animate={{
                                x: '-300px', // 왼쪽 화면 밖으로 이동
                                y: [100, 70, 100, 70, 100], // 물결 모양으로 위아래로 움직임
                            }}
                            onClick={onClickBox}
                            transition={{
                                duration: 10, // 10초 동안 이동
                                ease: 'linear', // 일정한 속도로 이동
                                y: {
                                    duration: 3, // y축 이동의 반복 주기
                                    repeat: Infinity,
                                    ease: 'linear',
                                },
                            }}
                        />
                    )}

                    {showGoldText && (
                        <>
                            <AnimatePresence>
                                {
                                    bangState
                                        ?
                                        <img src='/newImg/vfx_confetti.gif'
                                            style={{
                                                position: 'absolute',
                                                top: `${textPosition.top - 120}px`,
                                                left: `${textPosition.left - 20}px`,
                                                width: '400px',
                                                zIndex: 1000,
                                            }}
                                        />
                                        :
                                        ""
                                }
                                <motion.div
                                    initial={{ opacity: 0, x: 10, y: -70 }}
                                    animate={{ opacity: 1, x: 10, y: -120 }}
                                    exit={{ opacity: 0 }}
                                    style={{
                                        position: 'absolute',
                                        top: textPosition.top,
                                        left: textPosition.left + 80,
                                        fontSize: '40px',
                                        fontWeight: "bold",
                                        color: 'gold',
                                        zIndex: '1001',
                                    }}
                                    transition={{ duration: 1 }}
                                >
                                    +{changeNum(jackpotAmt)}
                                </motion.div>
                            </AnimatePresence>
                        </>
                    )}

                    {SuperBoxModal && (
                        <div style={{
                            pointerEvents: "none",
                            position: 'absolute',
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: '100%',
                            aspectRatio: "1/1",
                            zIndex: 100,
                        }}>
                            <video
                                className="img"
                                autoPlay
                                loop
                                muted
                                playsInline
                                poster={SuperJackpotImg?.video?.[0]?.video_url ?? "/newImg/super_jackpot_box_motion.mp4"}  // ← 이미지로 교체
                                preload="auto"
                                style={{
                                    pointerEvents: "none",
                                    width: '100%',
                                    aspectRatio: "1/1",
                                    // zIndex: 1000,
                                }}
                            >
                                <source src={SuperJackpotImg?.video?.[0]?.video_url ?? "/newImg/super_jackpot_box_motion.mp4"} type="video/mp4" />
                            </video>
                            {SuperBoxTextModal && (
                                <div
                                    className='superBox-fadout'
                                    style={{
                                        position: "absolute",
                                        left: "50%",
                                        bottom: "16%",
                                        transform: "translateX(-50%)",
                                        fontSize: "18px",
                                        fontWeight: "500",
                                        letterSpacing: "2px",
                                        animation: "fadeOut 4s forwards", // 3초 동안 점점 옅어짐
                                    }}
                                >
                                    {superText}
                                </div>
                            )}
                        </div>
                    )}
                </>

                <div className="main-2" style={{ paddingTop: adsHeightState === 3 || adsHeightState === 0 ? "20px" : "0" }}>
                    <div style={{ position: "relative" }}>
                        <div className="main-2-header" style={{ zIndex: "101", position: "relative" }}>
                            <img src="/newImg/icon_main_diamond.png" className="img_diamond" alt="Diamond" style={{ pointerEvents: "none" }} />
                            <div className='fontNumber'>
                                <SlotCounter value={changeNum(gold)}
                                    duration={0.2}
                                    autoAnimationStart={false}
                                    sequentialAnimationMode
                                />
                            </div>
                        </div>
                        <div className="main-2-img"
                            ref={imgRef}
                            onPointerDown={handlePointerDown}
                            onPointerUp={resetTilt}
                        >
                            {hearts.map((heart) => (
                                <div
                                    key={heart.id}
                                    alt="Heart"
                                    className='heart number'
                                    style={{ left: `${heart.x}px`, top: `${heart.y}px` }}>
                                    +{checkEnergy > 0 ? tapUpgradeValue : 0}
                                </div>
                            ))}
                            <animated.img
                                ref={imageRef}
                                src={circleImg}
                                alt="Center"
                                className="center-img"
                                style={{
                                    ...tiltStyle,
                                    width: '80%',
                                    // width: '100%',
                                    minWidth: '280px',
                                    cursor: 'pointer',
                                    marginTop: "15px",
                                    // marginTop: "30px"
                                }}
                                draggable="false" // 드래그 방지
                                onLoad={() => setCenterImgLoad(true)}
                            />
                            {
                                centerImgLoad && (
                                    <animated.img
                                        src={`${process.env.REACT_APP_API}${mySkin.skin_img}`}
                                        alt="Hamster"
                                        className="hamster-img"
                                        style={{
                                            ...jumpStyle,
                                        }}
                                    />
                                )
                            }
                        </div>
                        {/* <div style={{ position: 'relative', width: '80%', minWidth: '280px', margin: '5px auto 0' }}>
                            <ProgressBar
                                completed={invitedCount}
                                maxCompleted={maxInvite}
                                width="100%"               
                                customLabel=""
                                labelColor="transparent"
                                bgColor="#5863FF"
                                baseBgColor="#373737"
                                height="20px"
                                animateOnRender={false}
                                borderRadius="50px"
                            />

                            <div
                                style={{
                                    position: 'absolute',
                                    top: 0, left: 0, right: 0,
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: '#FFFFFF',
                                    fontWeight: 500,
                                    fontSize: '12px',
                                }}
                            >
                                {`${invitedCount * 100 / maxInvite}%`}
                            </div>
                            {thresholds.map((value) => {
                                const reached = invitedCount >= value;
                                const leftPct = (value / maxInvite) * 100;

                                return (
                                    <div
                                        key={value}
                                        style={{
                                            position: 'absolute',
                                            left: `${leftPct}%`,
                                            top: 0,
                                            bottom: 0,
                                            transform: 'translateX(-1px)',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: '100%',
                                                transform: 'translateX(-50%)',
                                                marginTop: '2px',
                                                fontSize: '11px',
                                                color: reached ? '#fff' : '#aaa'
                                            }}
                                        >
                                            {value}
                                        </div>
                                    </div>
                                );
                            })}
                        </div> */}
                    </div>
                </div>
                <div className="main-3" style={{ zIndex: "101" }}>
                    <div>
                        <div className="main-3-1 fontNumber" style={{ gap: "7px" }}>
                            <img src="/img/lightning.png" className="main-3-1-img" style={{ pointerEvents: "none", width: "19px" }} />
                            <div>
                                <span>{changeNum(energy)}/{changeUnitsOrigial(limitUpgradeValue)}</span>
                            </div>
                        </div>
                    </div>
                    <div className="main-3-1" style={{ gap: "7px", paddingRight: "20px" }} onClick={() => setInfoModal(true)}>
                        <img src="/img/boost.png" className="main-3-1-img" style={{ pointerEvents: "none", width: "33px" }} />
                        <div>{t('main_0')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function AirdropModal({ setInfoModal, upgrade, setMessage }) {
    const { t } = useTranslation();

    let tapUpgrade = useSelector((state) => { return state.tapUpgrade.value })
    let limitUpgrade = useSelector((state) => { return state.limitUpgrade.value })

    let [detail, setDetail] = useState(false)
    let [clickData, setClickData] = useState("")

    let [nextTap, setNextTap] = useState([])
    let [nextLimit, setNextLimit] = useState([])

    useEffect(() => {
        let tap = upgrade["tab-plus"]
        let limit = upgrade["energy-limit"]

        for (let i = 0; i < tap.length; i++) {
            if (tapUpgrade == tap.length) {
                setNextTap({ "name": tap[0].up_type, "coin": "max" })
            }
            else if (tapUpgrade + 1 == tap[i].up_level) {
                setNextTap({ "name": tap[i].up_type, "coin": tap[i].up_price, "level": tap[i].up_level, "value": tap[i].up_value })
            }
        }
        for (let i = 0; i < limit.length; i++) {
            if (limitUpgrade == limit.length) {
                setNextLimit({ "name": limit[0].up_type, "coin": "max" })
            }
            else if (limitUpgrade + 1 == limit[i].up_level) {
                setNextLimit({ "name": limit[i].up_type, "coin": limit[i].up_price, "level": limit[i].up_level, "value": limit[i].up_value })
            }
        }
    }, [upgrade])

    return (
        <div className='modal'>
            {detail && (<AirdropModalItem setDetail={setDetail} setInfoModal={setInfoModal} clickData={clickData} nextTap={nextTap} nextLimit={nextLimit} setMessage={setMessage} />)}
            <div className='modal-background' onClick={() => setInfoModal(false)}></div>
            <div className='airdrop-modal' style={{ minHeight: "370px" }}>
                <FontAwesomeIcon icon={faCircleXmark} className='modal-x' onClick={() => setInfoModal(false)} />
                <img src="/img/boost.png" className="main-3-1-img" style={{ pointerEvents: "none", width: '70px', marginBottom: "5px" }} />
                <div style={{ fontSize: '27px', fontWeight: "500", marginBottom: "15px" }}>{t('main_1')}</div>
                <div className='friend-list' style={{ gap: '10px', marginBottom: "10px" }} onClick={() => { setClickData("Multi tap"); setDetail(true) }}>
                    <img src='/img/tab_boost.png' style={{ width: "45px" }} />
                    <div className='friend-list-text'>
                        <div style={{ fontWeight: '500', fontSize: '14px' }}>
                            <span style={{ color: "#ffbb3f", marginRight: "6px", fontWeight: "bold" }}>
                                {
                                    nextTap.coin == "max"
                                        ?
                                        "Lv.max"
                                        :
                                        `Lv.${tapUpgrade}`
                                }
                            </span>
                            {t('main_2')}
                        </div>
                        {
                            nextTap.coin == "max"
                                ?
                                ""
                                :
                                <div className='friend-list-text-1'>
                                    <img src="/newImg/icon_main_diamond.png" className="img_diamond" alt="Diamond" style={{ pointerEvents: "none", width: "18px", marginRight: "3px" }} />
                                    <span className='fontNumber' style={{ marginRight: "3px" }}>{changeNum(nextTap.coin)}</span>
                                </div>

                        }
                    </div>
                    <ChevronRight className='settings-list-icon' size={32} />
                </div>
                <div className='friend-list' style={{ gap: '10px', marginBottom: "10px" }} onClick={() => { setClickData("Energy limit"); setDetail(true) }}>
                    <img src='/img/energy_boost.png' style={{ width: "45px" }} />
                    <div className='friend-list-text'>
                        <div style={{ fontWeight: '500', fontSize: '14px' }}>
                            <span style={{ color: "#ffbb3f", marginRight: "6px", fontWeight: "bold" }}>
                                {
                                    nextLimit.coin == "max"
                                        ?
                                        "Lv.max"
                                        :
                                        `Lv.${limitUpgrade}`
                                }
                            </span>
                            {t('main_3')}
                        </div>
                        {
                            nextLimit.coin == "max"
                                ?
                                ""
                                :
                                <div className='friend-list-text-1'>
                                    <img src="/newImg/icon_main_diamond.png" className="img_diamond" alt="Diamond" style={{ pointerEvents: "none", width: "18px", marginRight: "3px" }} />
                                    <span className='fontNumber' style={{ marginRight: "3px" }}>{changeNum(nextLimit.coin)}</span>
                                </div>
                        }
                    </div>
                    <ChevronRight className='settings-list-icon' size={32} />
                </div>
            </div>
        </div>
    )
}

function AirdropModalItem({ setDetail, setInfoModal, clickData, nextTap, nextLimit, setMessage }) {
    const { t } = useTranslation();
    let gold = useSelector((state) => { return state.gold.value })
    let energy = useSelector((state) => { return state.energy.value })
    let tapUpgrade = useSelector((state) => { return state.tapUpgrade.value })
    let limitUpgrade = useSelector((state) => { return state.limitUpgrade.value })
    let tapUpgradeValue = useSelector((state) => { return state.tapUpgradeValue.value })
    let limitUpgradeValue = useSelector((state) => { return state.limitUpgradeValue.value })
    let JWT = useSelector((state) => { return state.JWT.value })

    let dispatch = useDispatch()

    const [buyBtn, setBuyBtn] = useState(false)

    let item = clickData == "Multi tap" ? tapUpgrade : limitUpgrade
    let up = clickData == "Multi tap" ? nextTap : nextLimit
    let value = clickData == "Multi tap" ? tapUpgradeValue : limitUpgradeValue


    const UpgradeLevel = async () => {
        setBuyBtn(true)
        if (up.coin != "max" && gold - up.coin >= 0) {
            await axios.post(process.env.REACT_APP_API + '/api/upgrade', {
                item: up.name,
                level: up.level
            }, {
                headers: { Authorization: `Bearer ${JWT}` }
            }).then((response) => {
                let tmp = response.data
                if (tmp?.code == 1000) {
                    setTimeout(() => {
                        if (clickData == "Multi tap") {
                            dispatch(checkTapUpgrade(up.level))
                            dispatch(checkTapUpgradeValue(up.level))
                            setMessage({ "code": 0, "msg": `${t('message_0')} ${up.level} ${t('message_0_1')}` })
                        }
                        else {
                            dispatch(changeEnergy(energy + up.value - limitUpgradeValue))
                            dispatch(checkLimitUpgrade(up.level))
                            dispatch(checkLimitUpgradeValue(up.value))
                            setMessage({ "code": 0, "msg": `${t('message_1')} ${up.level} ${t('message_1_1')}` })
                        }
                        dispatch(changeAlramModal())
                        dispatch(changeGold(gold - up.coin))
                        setBuyBtn(false)
                        setInfoModal(false)
                    }, 1000)
                }
                else {
                    setTimeout(() => {
                        setBuyBtn(false)
                    }, 1000)
                }
            }).catch((error) => {
                if (error?.status === 999) {
                    dispatch(checkDuplicateLogins(true))
                }
                else {
                    console.log(error)
                }
            })
        }
    };

    return (
        <div className='modal'>
            <div className='modal-background' onClick={() => setInfoModal(false)}></div>
            <div className='airdrop-modal' style={{ minHeight: "370px" }}>
                <FontAwesomeIcon icon={faCircleXmark} className='modal-x' onClick={() => setDetail(false)} />
                {
                    clickData == "Multi tap"
                        ?
                        <img src="/img/tab_boost.png" className="main-3-1-img" style={{ pointerEvents: "none", width: '80px', marginBottom: "5px" }} />
                        :
                        <img src="/img/energy_boost.png" className="main-3-1-img" style={{ pointerEvents: "none", width: '80px', marginBottom: "5px" }} />
                }
                <div style={{ fontSize: '27px', fontWeight: "500", marginBottom: "15px" }}>{clickData}</div>
                {
                    up.coin == "max"
                        ?
                        <div style={{ marginBottom: "5px", display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ffbb3f' }}>
                            Lv.{up.coin}
                        </div>
                        :
                        <div className='fontNumber' style={{ marginBottom: "5px", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <img src="/newImg/icon_main_diamond.png" className="img_diamond" alt="Diamond" style={{ pointerEvents: "none", width: "18px", marginRight: "3px" }} />
                            {changeNum(up.coin)}
                        </div>
                }
                {
                    up.coin == "max"
                        ?
                        <div style={{ height: "50px" }}></div>
                        :
                        <>
                            <div style={{ marginBottom: "5px", display: "flex", alignItems: 'center', justifyContent: 'center', color: '#ffbb3f' }}>
                                Lv.{item}<ChevronRight size={20} style={{ margin: "0px 20px" }} />Lv.{item + 1}
                            </div>
                            <div className='fontNumber' style={{ marginBottom: "15px", display: "flex", alignItems: 'center', justifyContent: 'center', color: '#ffbb3f' }}>
                                {changeNum(value)}<ChevronRight size={20} style={{ margin: "0px 20px" }} />{changeNum(up.value)}
                            </div>
                        </>
                }
                <div style={{ fontSize: "13px", marginBottom: '20px' }}>
                    {
                        clickData == "Multi tap"
                            ?
                            t('main_4')
                            :
                            t('main_5')
                    }
                </div>
                {
                    up.coin == "max"
                        ?
                        ""
                        :
                        <div className='modal-airdrop-btn' onClick={() => { !buyBtn && UpgradeLevel() }}>
                            {
                                buyBtn
                                    ?
                                    <BeatLoader size={13} color="#003577" />
                                    :
                                    t('main_6')
                            }
                        </div>
                }
            </div>
        </div>
    )
}

export default Main;
